import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectPrivacyFragment = { __typename?: 'Project', private: boolean };

export const ProjectPrivacy = /*#__PURE__*/ gql`
    fragment ProjectPrivacy on Project {
  private
}
    ` as unknown as DocumentNode<ProjectPrivacyFragment, unknown>;

        

        
export const useProjectPrivacyFragment = (
  input: string | Omit<UseFragmentOptions<ProjectPrivacyFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectPrivacyFragment>({
    fragment: ProjectPrivacy,
    fragmentName: 'ProjectPrivacy',
    ...options,
  });
};
  
        